"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.permissions = void 0;
/* Permissions
 * Allowed Layers defines what layers are available to the userType.
 */

var BASE_LAYERS = ['regular_outages', 'critical_outages', 'county', 'zip', 'townWard', 'both_tf', 'critical_tf'];
var BASE_PERMISSIONS = {
  allowedLayerVisibility: BASE_LAYERS.concat(['outages_lite']),
  defaultOutageLayer: 'outages_lite',
  defaultThematicLayer: 'county'
};
var ADMIN_PERMISSIONS = {
  allowedLayerVisibility: BASE_LAYERS.concat(['outages', 'managed_outages', 'both_outages']),
  defaultOutageLayer: 'outages',
  defaultThematicLayer: 'county'
};
var permissions = {
  COUNTY_LIAISON: BASE_PERMISSIONS,
  COUNTY_USER: BASE_PERMISSIONS,
  MUNI_USER: BASE_PERMISSIONS,
  LIAISON: BASE_PERMISSIONS,
  COMED_ADMIN: ADMIN_PERMISSIONS,
  COMED_USER: ADMIN_PERMISSIONS,
  EXTERNAL_AFFAIRS_MANAGER: ADMIN_PERMISSIONS,
  ACCOUNT_MANAGER: ADMIN_PERMISSIONS,
  UNKNOWN: {
    allowedLayerVisibility: [],
    defaultOutageLayer: '',
    defaultThematicLayer: ''
  }
};
exports.permissions = permissions;
var _default = permissions;
exports.default = _default;